<router-outlet></router-outlet>
<berry-screen-size-not-supported></berry-screen-size-not-supported>